import React from "react";
import { Button, Popup } from "semantic-ui-react";
const ButtonWithPopup = ({ label, labelWhenDisabled, icon, disabled, loading, dataTestid, color, size, onClick }) => {
    return React.createElement(React.Fragment, null, React.createElement(Popup, { basic: true, position: "top center", hoverable: true, content: disabled ? labelWhenDisabled : label, trigger: React.createElement("span", null,
            React.createElement(Button, { icon: icon, disabled: disabled, loading: loading, "data-testid": dataTestid, onClick: onClick, color: color, size: size })) }));
};
export default ButtonWithPopup;
